export default "__VITE_ASSET__uYb_lFA9__"